import * as actionType from './vendorAction';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';
import LZString from 'lz-string';
const config = JSON.parse(Config);
const apiInterface = config['api1'];
const initialState = {
    message: '',
    modalOpen: false,
    loading: false,
    apiStatus:false,
}
export const GetVendorLIst = (data) => ({
    type: actionType.GET_VENDOR_LIST,
    payload: data,
})
export const GetVendorContractLIst = (data) => ({
    type: actionType.GET_VENDOR_CONTRACT_LIST,
    payload: data,
})
export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})
export const FilterVendor = (data) => ({
    type: actionType.GET_SELECTED_VENDOR,
    payload: data,
})
export const SelectedVendor = (data) =>({
    type:actionType.GET_SELECTED_VENDOR_FOR_SETTING,
    payload:data,
})
export const isEditVendor = (payload) => ({
    type: actionType.IS_VENDOR_EDIT,
    payload
  })
  export const isVendorCreate = (payload) => ({
    type: actionType.IS_VENDOR_CREATE,
    payload
  })
  export const isVendorList = (payload) => ({
    type: actionType.IS_VENDOR_LIST,
    payload
  })
  export const saveVendorSupplyList = (payload) => ({
    type: actionType.GET_VENDOR_SUPPLY_LIST,
    payload
  })
  
// export const getloadVendorSupply=(vendor_row_id,record)=>async(dispatch)=>{
//     const jsonData = Cookie.get('currentUser');
//               let decompressedData = LZString.decompressFromBase64(jsonData);
//           decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
//     const user = JSON.parse(decompressedData)
//        let value={
//         "fedid": user["userId"],
//         vendor_row_id  
//     }
//     initialState.loading = true;
//     dispatch(apiCallStatus(initialState))
//  ApiGateWay.PostCall1(apiInterface + '/VendorInfo/loadvendorsupplydetails',value).then(res=>{console.log(res,'res')
//      let data=[]
//     if(res[0]?.Table1[0]?.status_code=='000'){
//         let supplyData=res[1]?.Table2;
//         supplyData.forEach(ele=>{
//             data.push({
//                 city_id:ele.city,
//                 state_id:ele.state,
//                 gst_number:ele.gst_number,
//                 third_number:ele.third_number,
//                 vendor_row_id:ele.vendor_row_id,
//                 vendor_supply_row_id:ele.vendor_supply_row_id,
//                 zone_id:ele.zone,
//                 isEdit:true,
//             })
          
//         })
//         // record.supplyDetail=data;
//     //  dispatch(FilterVendor(record))  ;
//     const updatedRecord = { ...record, supplyDetail: data };
// dispatch(FilterVendor(updatedRecord));

//     //  dispatch(isEdit(true));
//     //   dispatch(saveVendorSupplyList(res[1]?.Table2));
     
     
//     }else{
//         initialState.loading = false;
//         initialState.message = res[0]?.Table1[0]?.status_msg;
//         initialState.modalOpen = true;
//         dispatch(apiCallStatus(initialState))
//     }
  
//  }).catch(err=>{
//     initialState.loading = false;
//     dispatch(apiCallStatus(initialState))
//  })
// }
export const getloadVendorSupply = (vendor_row_id, record) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData === '\x00\x00\x00' ? jsonData : decompressedData;
    const user = JSON.parse(decompressedData);

    let value = {
        "fedid": user["userId"],
        vendor_row_id
    };

    try {
        initialState.loading = true;
        dispatch(apiCallStatus(initialState));

        const res = await ApiGateWay.PostCall1(apiInterface + '/VendorInfo/loadvendorsupplydetails', value);
        console.log(res, 'res');
        
        if (res[0]?.Table1[0]?.status_code === '000') {
            let supplyData = res[1]?.Table2;
            let data = supplyData.map(ele => ({
                city_id: ele.city,
                state_id: ele.state,
                gst_number: ele.gst_number,
                third_number: ele.third_number,
                vendor_row_id: ele.vendor_row_id,
                vendor_supply_row_id: ele.vendor_supply_row_id,
                zone_id: ele.zone,
                isEdit: true,
            }));

            const updatedRecord = { ...record, supplyDetail: data };
            dispatch(FilterVendor(updatedRecord));
        } else {
            initialState.loading = false;
            initialState.message = res[0]?.Table1[0]?.status_msg;
            initialState.modalOpen = true;
            dispatch(apiCallStatus(initialState));
        }
    } catch (err) {
        initialState.loading = false;
        dispatch(apiCallStatus(initialState));
    }
};


export const getSelectedVendor=(vendor_row_id,record)=>async(dispatch)=>{
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
        let value={
        "fedid": user["userId"],
        vendor_row_id  
    }
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
 ApiGateWay.PostCall1(apiInterface + '/VendorInfo/loadvendorsupplydetails',value).then(res=>{
     let data=[]
     let supplyData=res[2]?.Table3
     let documentData = res[3]?.Table4
     
     dispatch(SelectedVendor({supplyData,documentData}))
  
 }).catch(err=>{
    initialState.loading = false;
    dispatch(apiCallStatus(initialState))
 })
}
export const setAssetDetails = (payload) => {
    return{
        type: actionType.GET_ASSET_DETAILS,
        payload
  }}
export const getAssetDetails=(payload)=>async(dispatch)=>{
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    // const value = {
    //     "fed_id": user["userId"],
    //     "store_id":payload.storeId,
    //     "vendor_id": payload.vendorId,
    //     "subcategory_id":payload.subcategoryId
    // }
    const value ={
        "fed_id":user["userId"],
        "store_id":payload.storeId,
        "vendor_id": payload.vendorId,
        "subcategory_id":payload.subcategoryId
    }
 ApiGateWay.GetAsset(apiInterface + '/VendorInfo/updateassetlistforvendor',value).then(res=>{
    const result = JSON.parse(res);
    if(result[0].Table1[0].status_code === "000"){
        let data = result[1].Table2;
        return dispatch(setAssetDetails(data))
    }else{
        dispatch(setAssetDetails([]))
    }
    //  let data=[]
    //  let supplyData=res[2]?.Table3
    //  let documentData = res[3]?.Table4
     
    //  dispatch(SelectedVendor({supplyData,documentData}))
  
 }).catch(err=>{
    initialState.loading = false;
    dispatch(apiCallStatus(initialState))
 })
}
export const doGetVendorList = () => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
        const data = {
        "fedid": user["userId"],
    }
    ApiGateWay.SaveData(
        apiInterface +
        '/VendorInfo/loadallvendorsinfo',data)
        .then((response) => {
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const StateList = response[1]?.Table2;
                const ZoneList = response[2]?.Table3;
                const CityList = response[3]?.Table4;
                const ServiceList = response[6]?.Table7;
                const StoreList = response[7]?.Table8;
                const VendorList = (response[5]?.Table6).reverse();
                const uniqueIds = []
                const VendorNameList = response[5]?.Table6.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.id);
                    if (!isDuplicate) {
                        uniqueIds.push(element.id);
                        return true;
                    }
                    return false;
                });
                VendorList.forEach(element => {
                   element.vendorStatus=element.vendor_status==1?'Active':'InActive'; 
                });
                console.log(VendorList,'vendorList from VendorService')
                const VendorData = { StateList, ZoneList, CityList, ServiceList, VendorList, VendorNameList, StoreList }
                initialState.message = ''
                initialState.modalOpen=false;
                initialState.apiStatus = false;
                dispatch(GetVendorLIst(VendorData))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response[0]?.Table1[0]?.status_msg;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}

export const SaveVendorInfo = (values) => async (dispatch) => {
    console.log(values,'value')
    values.vendor_supply_details.forEach(ele=>{
        delete ele.isEdit;
    })
    // values?.vendor_supply_details?.map(ele=>delete ele.isEdit)
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/VendorInfo/updatevendorinfo', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.apiStatus=true;
                initialState.message ="Successfully submitted"
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result[1]?.Table2[0]?.status_msg
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const SaveVendorContractMappingInfo = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/VendorInfo/updatevendorcontractmappinginfo', values)
        .then((result) => {
            console.log(result+ 'dispatch')
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = "Successfully updated"
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result[1]?.Table1[2]?.status_msg
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const doGetVendorContractList = (fedid) => async (dispatch) => {
   let data={
    fedid
    }
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/VendorInfo/loadallvendorcontract',data)
        .then((response) => {
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const StoresDropdown = response[1]?.Table2;
                const MainCategory = response[2]?.Table3;
                const SubCategory = response[3]?.Table4;
                const AssetList = response[4]?.Table5;
                const VendorsDropDown = response[5]?.Table6;
                const VendorsContractMappingList=response[6]?.Table7;
                const VendorsServices = response[7].Table8;
                const ExistingContracts = response[8].Table9;
                const AllowCreateOrEdit = response[10].Table11[0].allow_edit_create_vendor_contract;
                const VendorContractData = { StoresDropdown, MainCategory, SubCategory, AssetList, VendorsDropDown,VendorsServices ,VendorsContractMappingList,ExistingContracts,AllowCreateOrEdit}
                initialState.message = ''
                initialState.modalOpen = false
                dispatch(GetVendorContractLIst(VendorContractData))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response[0]?.Table1[0]?.status_msg;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const apiCallStatus = (data) => (dispatch) => {
    dispatch(apiStatus(data))
}
// export const getSelectedVendorList = (data) => (dispatch) => {
//     dispatch(FilterVendor(data))
// }
export const isEdit=(data)=>(dispatch)=>{
    dispatch(isEditVendor(data))
  }
  export const addVendor=(data)=>(dispatch)=>{
    dispatch(isVendorCreate(data))
  }
  export const VendorList=(data)=>(dispatch)=>{
    dispatch(isVendorList(data))
  }